import axios from 'axios'
import router from '@/router';

function getShopAndProject() {
    const shop_code = router.currentRoute.value.query.shop_code;
    const project = router.currentRoute.value.query.project;

    return { shop_code, project_code: project };
}

export const сorporateBanketsModule = {
    namespaced: true,

    state: () => ({
        currentOrder: null,
        stateSearchQuery: '',
        products: null,
        pages: null,
        summary: null
    }),

    mutations: {
        setSummary(state, data) {
            state.summary = data
            console.log(data);
        },

        setCurrentOrder(state, data) {
            if (data.delivery_datetime_to) {
                data.delivery_date_to = data.delivery_datetime_to.split('T')[0];
                data.delivery_time_to = data.delivery_datetime_to.split('T')[1]?.substring(0, 5) || '';
                data.delivery_date_to_initial = data.delivery_date_to;
                data.delivery_time_to_initial = data.delivery_time_to;
            }
            // Сохраняем исходное значение скидки
            data.discount_amount_initial = data.discount_amount;
            data.additional_price_initital = data.additional_price
            data.prepayment_amount_initital = data.prepayment_amount
            data.items?.forEach(item => item.edited = false);
            state.currentOrder = data;
        },

        setSearchQuery(state, searchQuery) {
            state.stateSearchQuery = searchQuery;
        },

        setPages(state, data) {
            state.pages = data;
        },

        setEdited(state, bool) {
            state.edited_succes = bool;
        }
    },

    actions: {
        async getCurrentOrder({ commit }, id) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.get(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/orders/${id}`,
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                if(response.status == 200) {
                    return response.data
                }
            })
            .catch ((error) => {
                console.log(error);
            })
        },

        async changeOrderStatus({ dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            try {
                const { data: resp } = await axios.get(
                    `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}/?status=${data.status}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
                if (resp.success) {
                    console.log(resp);
                }
            } catch (error) {
                console.log(error.response);
            }
        },

        async sendInvoice({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            try {
                await axios.get(
                    `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}?${data.type}=true`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
            } catch (error) {
                console.log(error);
            }
        },

        async orderDelete({}, id) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.get(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${id}/?order_del=true`,
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                if(response.status == 200) {
                    return true
                }
            })
            .catch((error) => {
                console.log(error);
            })
        },

        async changeOrderProductEdit({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.post(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order.id}/`,
                { items: data.items },
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            ).then(( response ) => {
                if(response.status == 200) {
                    if(response.data.success) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            })
        },

        async orderProductDelete({ rootState }, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            rootState.isLoading = true;
            let url = `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order_id}/?`;
            url += !data.item.is_cancelled ? `item_del=${data.item.id}` : `item_return=${data.item.id}`;

            return axios.get(url, {
                headers: { Authorization: 'Token ' + localStorage.getItem('token') }
            })
            .then((response) => {
                if(response.status == 200) {
                    rootState.isLoading = false;
                    return response.data
                } else {
                    rootState.isLoading = false;
                }
            })
            .catch((error) => {
                console.log(error);
                rootState.isLoading = false;
            })
        },

        async changeOrderProductPrice({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            try {
                await axios.get(
                    `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order_id}/?item_edit=${data.item_id}&item_price=${data.item_price}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
            } catch (error) {
                console.log(error.response);
            }
        },

        async changeOrderProductRatio({ }, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            try {
                await axios.get(
                    `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order_id}/?item_edit=${data.item_id}&item_ratio=${data.item_ratio}`,
                    { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
                );
            } catch (error) {
                console.log(error.response);
            }
        },

        async orderDownload({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            try {
                const response = await axios.get(
                    `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}/?export=${data.type}&with_signature=${data.signature}`,
                    {
                        headers: { Authorization: 'Token ' + localStorage.getItem('token') },
                        responseType: 'blob'
                    }
                );
                const url = URL.createObjectURL(response.data);
                const a = document.createElement('a');
                a.href = url;
                if (data.type == 'xlsx') {
                    a.download = `Заказ_№${data.id}.xls`;
                } else if (data.type == 'act') {
                    a.download = `Акт_заказа_${data.id}.doc`;
                } else if(data.type == 'prepayment_invoice'){
                    a.download = `Счет_на_предоплату_${data.id}.doc`;
                } else if(data.type == 'invoice') {
                    a.download = `Счет_на_оплату_${data.id}.doc`;
                } else if(data.type == 'upd_xml') {
                    a.download = `УПД_${data.id}.xml`;
                } else if(data.type == 'upd_xlsx') {
                    a.download = `УПД_${data.id}.xlsx`;
                }
                

                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (error) {
                console.log(error.response);
            }
        },

        async changeOrderComment({ dispatch }, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.post(
            `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}/`,
                { comment: data.comment },
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error);
            })
        },

        async fetchProducts({}, filters) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            let searchParam = '';
            if (filters.search && String(filters.search).trim() !== '') {
                searchParam = `&search=${encodeURIComponent(filters.search)}`;
            }
            
            let category = '';
            if (filters.category) {
                category = `&category=${encodeURIComponent(filters.category)}`;
            }

            return axios.get(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/products?ordering=name&available=for_corporate&page=${filters.page}${searchParam}${category}`,
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                if(response.status == 200) {
                    return response.data
                }
            })  
        },

        async fetchCategories({}) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.get(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/categories/?available=for_corporate`,
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                if(response.status == 200) {
                    return response.data
                }
            })
        },

        async addNewProduct({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.get(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order}?product_add=${data.product}`,
                { headers: { Authorization: 'Token ' + localStorage.getItem('token') } }
            )
            .then((response) => {
                if(response.status == 200) {
                    return response.data
                }
            })
            .catch((error) => {
                console.log(error);
            })
        },

        async saveOrderChanges({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            const params = new URLSearchParams();

            if (data.params) {
                Object.entries(data.params).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        if (value.length > 0) {
                            value.forEach(item => params.append(key, item));
                        } else {
                            params.append(key, '');
                        }
                    } else {
                        params.append(key, value);
                    }
                });
            } else if (Array.isArray(data.value)) {
                const key = data.item || 'table';
                if (data.value.length > 0) {
                    data.value.forEach(item => params.append(key, item));
                } else {
                    params.append(key, '');
                }
            } else if (data.item) {
                params.append(data.item, data.value);
            }

            const query = params.toString()

            return axios.get(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.id}?${query}`,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                }
            )
                .then((response) => {
                    if (response.status == 200) {
                        return response.data
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },

        async orderCounteragentActDownload({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios
            .get(`https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/personal/order-edit/${data.order.id}/?export=act_reconciliation&date_from=${data.dateFrom}&date_to=${data.dateTo}`,
                {
                    headers: { Authorization: 'Token ' + localStorage.getItem('token') },
                    responseType: 'blob'
                })
                .then((response) => {
                    const url = URL.createObjectURL(response.data);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `Акт_сверки_${data.order.counteragent.name}_${data.dateFrom}-${data.dateTo}.doc`;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    URL.revokeObjectURL(url);

                    return true
                })
                .catch((error) => {
                    console.log(error)
                    return false;
                });
        },

        async orderRefund({}, data) {
            const { shop_code, project_code } = getShopAndProject();
            if (!shop_code || !project_code) return;

            return axios.post(
                `https://backend.tcode.online/api/projects/${project_code}/shops/${shop_code}/order-refund/`,
                {
                    order_id: data.id,
                    refund_sum: data.payment_sum
                },
                {
                    headers: { Authorization: 'Token ' + localStorage.getItem('token') }
                }
            )
            .then((response) => {
                if(response.status == 200) {
                    if(response.data.success) {
                        return response.data.success
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    return { error: error.response.data.error}
                }
            })  
        },
    }
}